export const COBRANDED_COMMON_QUESTIONS_RAW_RESULT = {
  id: '23e54eb7-f89d-4142-8ac2-2ac0d35ff1c9',
  content: {
    'pergunta-1':
      'Após o pagamento da fatura do meu cartão Smiles, em quanto tempo as milhas entram na minha conta?',
    'resposta-1':
      'Em até 3 dias úteis as milhas estarão na sua conta Smiles. Se isso não acontecer, você deverá entrar em contato com o banco emissor do seu Cartão Smiles.',
    'pergunta-2':
      'Como eu sei se quantidade de milhas que acumulei com o cartão Smiles está correta?',
    'resposta-2':
      'Divida o valor que você pagou na última fatura pelo valor do dólar no dia do fechamento e depois multiplique pelo conversor da categoria do seu cartão. Veja um exemplo:<br><br>Pagamento da última fatura: R$ 1.785,00<br>Dólar no fechamento da fatura: R$ 3,15<br>Cartão Platinum: 2 milhas por dólar gasto<br>1785 / 3,15 x 2 = 1133<br>Você deveria ganhar 1133 milhas.',
    'pergunta-3':
      'As milhas que ganhei ao pedir o meu cartão não aparecem no meu extrato. Por quê?',
    'resposta-3':
      'As milhas bônus de aquisição são creditadas em até 4 parcelas, de acordo com o pagamento das parcelas da anuidade do seu Cartão. No extrato elas não aparecem como milhas bônus, e sim como milhas na fatura. Fique atento pois elas podem aparecer somadas às milhas que você acumulou pelas compras feitas com o Cartão.',
    'pergunta-5':
      'Após o pagamento da fatura do meu cartão Smiles, em quanto tempo as milhas entram na minha conta?',
    'resposta-5':
      'Em até 3 dias úteis as milhas estarão na sua conta Smiles. Se isso não acontecer, você deverá entrar em contato com o banco emissor do seu Cartão Smiles.',
  },
};

export const COBRANDED_COMMON_QUESTIONS_REFINED_RESULT = [
  {
    question:
      'Após o pagamento da fatura do meu cartão Smiles, em quanto tempo as milhas entram na minha conta?',
    answer:
      'Em até 3 dias úteis as milhas estarão na sua conta Smiles. Se isso não acontecer, você deverá entrar em contato com o banco emissor do seu Cartão Smiles.',
  },
  {
    question:
      'Como eu sei se quantidade de milhas que acumulei com o cartão Smiles está correta?',
    answer:
      'Divida o valor que você pagou na última fatura pelo valor do dólar no dia do fechamento e depois multiplique pelo conversor da categoria do seu cartão. Veja um exemplo:<br><br>Pagamento da última fatura: R$ 1.785,00<br><br>Dólar no fechamento da fatura: R$ 3,15<br><br>Cartão Platinum: 2 milhas por dólar gasto<br><br>1785 / 3,15 x 2 = 1133<br><br>Você deveria ganhar 1133 milhas.',
  },
  {
    question:
      'As milhas que ganhei ao pedir o meu cartão não aparecem no meu extrato. Por quê?',
    answer:
      'As milhas bônus de aquisição são creditadas em até 4 parcelas, de acordo com o pagamento das parcelas da anuidade do seu Cartão. No extrato elas não aparecem como milhas bônus, e sim como milhas na fatura. Fique atento pois elas podem aparecer somadas às milhas que você acumulou pelas compras feitas com o Cartão.',
  },
  {
    question:
      'Após o pagamento da fatura do meu cartão Smiles, em quanto tempo as milhas entram na minha conta?',
    answer:
      'Em até 3 dias úteis as milhas estarão na sua conta Smiles. Se isso não acontecer, você deverá entrar em contato com o banco emissor do seu Cartão Smiles.',
  },
];
